import React, { useContext, useEffect } from "react";
import { observer } from "mobx-react-lite";
import moment from "moment";
import { useInView } from "react-intersection-observer";

import {
  IonAvatar,
  IonItem,
  IonLabel,
  IonIcon,
  IonRow,
  IonText,
  IonCol,
} from "@ionic/react";

import { timeOutline } from "ionicons/icons";

import * as Models from "../../../models";
import { SessionContext } from "../../../session";
import { LinkifyIt } from "../../../utils/Helpers";

interface BroadcastMessagesListItemProps {
  broadcastMessage: Models.BroadcastMessage;
  onInView?: (broadcastMessage: Models.BroadcastMessage) => void;
}

const BroadcastMessagesListItem: React.FC<BroadcastMessagesListItemProps> =
  observer(({ broadcastMessage, onInView }) => {
    const [ref, inView, entry] = useInView({
      threshold: 0.5,
    });

    useEffect(() => {
      if (inView) {
        if (onInView) {
          onInView(broadcastMessage);
        }
      }
    }, [inView]);

    const session = useContext(SessionContext);
    if (!session) {
      return <></>;
    }

    if (
     broadcastMessage.loaded
    ) {
      const broadcastMessageDate = moment(broadcastMessage.createdAt).format(
        "h:mm A"
      );
      const broadcastMessageSender = "You";
      const broadcastMessageBody = broadcastMessage.body;

      return (
        <IonRow className={`ion-padding-top`}>
          <IonCol
            style={{
              display: "flex",
              margin: "auto",
              justifyContent:
                broadcastMessageSender == "You" ? "flex-end" : "flex-start",
            }}
          >
            <IonAvatar
              hidden={broadcastMessageSender == "You"}
              style={{
                height: "25px",
                width: "25px",
                minHeight: "25px",
                minWidth: "25px",
              }}
              //className="ion-margin-start"
            >
              <img src={undefined} />
            </IonAvatar>
            <IonItem
              ref={ref}
              color={broadcastMessageSender === "You" ? "primary" : "secondary"}
              lines="none"
              style={{
                minWidth: "100px",
                border: "1px",
                borderRadius:
                  broadcastMessageSender === "You"
                    ? "15px 3px 15px 15px"
                    : "3px 15px 15px 15px",
              }}
              className={
                broadcastMessageSender != "You"
                  ? "ion-margin-start"
                  : "ion-margin-end"
              }
            >
              <IonLabel className="ion-text-wrap">
                <p>
                  {broadcastMessageSender !== "You" && (
                    <b>{broadcastMessageSender}</b>
                  )}
                </p>
                <div style={{ userSelect: "text", WebkitUserSelect: "text", MozUserSelect: "text", msUserSelect: "text" }}>
                  <LinkifyIt>
                    <p style={{ whiteSpace: "pre-wrap" }}>
                      {broadcastMessageBody}
                    </p>
                  </LinkifyIt>
                </div>
                <div>
                  <p>
                    <IonText
                      color={broadcastMessageSender == "You" ? "light" : "dark"}
                    >
                      <span className="ion-text-end ion-float-right ion-align-items-end">
                        {broadcastMessage.status === "pending" ? (
                          <IonIcon icon={timeOutline} />
                        ) : (
                          <IonText style={{ fontSize: "12px" }}>
                            {broadcastMessageDate}
                          </IonText>
                        )}
                      </span>
                    </IonText>
                  </p>
                </div>
              </IonLabel>
            </IonItem>
            <IonAvatar
              hidden={broadcastMessageSender != "You" || true}
              style={{
                height: "25px",
                width: "25px",
                minHeight: "25px",
                minWidth: "25px",
              }}
              //className="ion-margin-start"
            >
              <img src={undefined} />
            </IonAvatar>
          </IonCol>
        </IonRow>
      );
    }

    return <></>;
  });

export default BroadcastMessagesListItem;
